<template>
  <div class="container">
    <div class="logoSpace">
      <div class="logo" @click="this.$router.push('/')"></div>
    </div>
    <div class="dashboard headerItem">
      <a href="/dashboard">ダッシュボード</a>
    </div>
    <div class="dataCatalog headerItem">
      <a
        href="https://catalog.dataplatform-yamanashi.jp/"
        target="”_blank”"
        rel="”noopener”"
        >データカタログ</a
      ><v-icon icon="mdi-open-in-new"></v-icon>
    </div>
    <div class="developmentPortal headerItem">
      <a href="/developer-portal/release">開発者ポータル</a>
    </div>
    <div class="contactSpace">
      <div class="contact" @click="goContact()">
        <v-icon icon="mdi-email-outline"></v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goContact() {
      location.href = "/#contact";
    },
  },
};
</script>

<style scoped>

a:link,
a:link,
a:visited,
a:hover,
a:active {
  font-weight: 600;
  color: black;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 10px;
}

.container {
  width: 100%;
  height: 80px;
  display: grid;
  grid-template-columns: 4fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "logoSpace dashboard dataCatalog developmentPortal contactSpace";
  align-self: center;
  font-size: 1vw;
}

.logoSpace {
  display: flex;
  align-items: center;
  padding: 0 0 0 40px;
}

.logo {
  height: 65%;
  aspect-ratio: 640 / 576;
  background-image: url("../assets/icon/logo.jpg");
  background-size: contain;
  cursor: pointer;
}

.headerItem {
  display: flex;
  justify-content: center;
  align-items: center;
}

.contactSpace {
  display: flex;
  align-items: center;
}

.contact {
  height: 2.5vw;
  aspect-ratio: 1/1;
  background-color: #d9b97e;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.5vw;
}

.contact:hover {
  cursor: pointer;
}
</style>
